
import { Switch, Route } from "react-router-dom";
import Home from "./pages/Home";
import Rapor from "./pages/Rapor";
import Main from "./components/layout/Main";
import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";

function App() {
  return (
    <div className="App">
      <Switch>
        <Main>
        <Route exact path="/" component={Home} />
        <Route exact path="/rapor" component={Rapor} />
        </Main>
      </Switch>
    </div>
  );
}

export default App;
